// firebase
import { db } from "config/firebase";
import { collection, setDoc, doc } from "firebase/firestore";

// utils
import unixTimestampInSeconds from "utils/unixTimestampInSeconds";

// A ---------------------------------------------------------------------- M

const addSeenTag = async (tagId, uuid, name, notes) => {
  try {
    const userRef = doc(db, "userdata", uuid);
    const seentagsRef = collection(userRef, "seentags");

    await setDoc(doc(seentagsRef, tagId), {
      nickname: name || "",
      notes: notes || "",
      firstseen: unixTimestampInSeconds(),
    });

    console.log(`Databox ${tagId} added to seen tags for user ${uuid}.`);
  } catch (error) {
    console.error(`Error in addSeenTag for databox ${tagId} and user ${uuid}:`, error);
  }
};

export default addSeenTag;
